module.exports = __webpack_public_path__ + "86a36b222dfef13ee7d05d6ed6dd15e0.gif";